<template>
  <div id="app">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-xs-12 col-md-7 col-lg-5 paddingToHide">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "app",
  computed: {
    ...mapState({
      navbarTitle: state => state.base.navbarTitle
    }),
    ...mapGetters({
      user: "getUser"
    })
  },
  methods: {
    ...mapActions(["setMessage"])
  },
  watch: {
    user(newValue) {
      if (newValue === null) {
        this.$router.push({ name: "Login" });
      }
    }
  }
};
</script>

<style lang="scss">
@import "./styles/app.scss";
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.paddingToHide {
  max-width: 400px !important;
  margin: auto;
}
</style>
